
import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";




const CorporateTeamBuildingTestimonial = ({ data }) => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "18%",
    autoplay: true,
    autoplaySpeed: 4500,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerPadding: "10%",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0px",
        },
      },
    ],
  };

  return (
    <section className="dynamic-testimonial-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7 dynamic-testimonial-heading text-center">
            <span className="main-title">
              {data.eyebrow}
            </span>

            <h2 className="heading">
              {data.title}
            </h2>
          </div>
        </div>
      </div>

      <div className="dynamic-testimonial-slider">
        <Slider {...settings}>
          {data.items.map((item) => (
            <div
              className="dynamic-testimonial-slide"
              key={item.id}
            >
              <div className="dynamic-testimonial-card">
                <div className="dynamic-testimonial-quote">
                  “
                </div>

                <p className="dynamic-testimonial-text">
                  {item.quote}
                </p>

                <div className="dynamic-testimonial-author">
                  {/* <div className="dynamic-testimonial-author-image">
                    <img
                      src={item.image}
                      alt={item.name}
                    />
                  </div> */}

                  <div className="dynamic-testimonial-author-content">
                    <h4 className="dynamic-testimonial-author-name">
                      {item.name}
                    </h4>

                    <p className="dynamic-testimonial-designation">
                      {item.designation}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default CorporateTeamBuildingTestimonial;

